import styled, { useTheme } from 'styled-components';
// import theme from '../../styles/theme';
import Text from './Text';

const getColor = (rate, theme) => {
  if (rate === 1) {
    return {
      bg: '#EAF3FE',
      border: theme.colors.status.info,
      text: 'info'
    };
  }
  if (rate >= 0.5) {
    return {
      bg: '#F2FAF6',
      border: theme.colors.status.success,
      text: 'success'
    };
  }
  return {
    bg: '#FEF9E9',
    border: theme.colors.status.warning,
    text: 'warning'
  };
};

const Container = styled.div`
  width: auto;
  height: 36px;
  padding: 8px 12px;
  background-color: ${({ $colors }) => $colors.bg};
  border: ${({ $isActive, $colors }) => ($isActive ? `1px solid ${$colors.border}` : 'none')};
  border-radius: 20px;
  padding: 8px 12px;
  cursor: ${({ cursor }) => cursor || 'pointer'};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SelectableChip = ({ label, $isActive, onSelect, rate, cursor }) => {
  const theme = useTheme();
  const colors = getColor(rate, theme);

  return (
    <Container $isActive={$isActive} onClick={onSelect} $colors={colors} cursor={cursor}>
      <Text variant="body2" color={colors.text}>{label}</Text>
    </Container>
  );
};

export default SelectableChip;
